module.exports = __webpack_public_path__ + "static/img/img-features-feature-2-game-7.51bcb48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-2-game-7.png
// module id = /cn2
// module chunks = 18